/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { redirect } from 'react-router-dom';

import {
  getDefaultTeamId,
  getTeamRole,
} from '@fai/friendli-suite/features/routes/loaders/apis/client-team';
import { ClientTeamMembershipRole } from '@fai/friendli-suite/generated/client/graphql';

export const onBoardingRedirection = (redirectPath: string) => async () => {
  const defaultTeamId = await getDefaultTeamId();
  const role = await getTeamRole({ teamId: defaultTeamId ?? '' });

  if (role === ClientTeamMembershipRole.Member) {
    return redirect(redirectPath);
  }

  return null;
};
